export default {
  name: 'env',
  api: 'https://api.dev.reservationslab.com/backend/',
  backendUrl: 'https://api.dev.reservationslab.com/backend/',
  ospUrl: 'https://api.dev.onestopparking.com/',
  googleRecaptcha: '6LcQlIQlAAAAALtOLoiNZkUcdOJJycfJ1ZO68MkB',
  googleKey: 'AIzaSyBZt5tUvyXDjRE4A8h3u2SqhXeDUxqq7As',
  parkingOtaUrl: 'https://dev.reservationslab.com'
}
